module.exports = __webpack_public_path__ + "static/media/20.9b7e1510.png";